import { array, boolean, object, optional, string } from 'zod';

import { countVisibleQuizText } from '@/shared/features/rich-text/utils/countVisibleQuizText';

export const CHOICE_TEXT_REQUIRED_MESSAGE = 'Choice text is required';
export const CHOICE_CONTENT_REQUIRED_MESSAGE =
  'Choice text or image is required';

/** 선택형 보기 글자 한도. 입력칸도 같은 값에서 막는다. 서버는 검사하지 않는다. */
export const MULTIPLE_CHOICE_TEXT_MAX_LENGTH = 300;

export const hasChoiceContent = (choice: {
  text?: string;
  imageUrl?: string;
}) => !!choice.text || !!choice.imageUrl;

export const QuizMultipleDataSchema = object({
  choiceList: array(
    object({
      key: string(),
      text: optional(string()),
      richText: optional(string()),
      imageUrl: optional(string()),
      isAnswer: boolean(),
    })
      .refine(hasChoiceContent, {
        message: CHOICE_CONTENT_REQUIRED_MESSAGE,
        path: ['text'],
      })
      .refine(
        ({ text = '' }) =>
          countVisibleQuizText(text) <= MULTIPLE_CHOICE_TEXT_MAX_LENGTH,
        {
          message: 'Choice text must be at most 300 characters',
          path: ['text'],
        },
      ),
  ).refine(
    data => {
      return data.some(choice => choice.isAnswer);
    },
    {
      message: 'At least one choice must be an answer',
      path: ['choiceList'],
    },
  ),
});
